export const EnergyType = {
    Gas: "gas",
    Electricity: "electricity"
}